import axios from "axios";
import qs from "qs";

export const AccessRefreshToken=async(username,password)=>{
    try{
        var data = qs.stringify({
            username: username,
            password: password,
            client_id: "admin-cli",
            grant_type: "password",
          });
        var config = {
            method: "post",
            url:
            `${window._env.REACT_APP_KEYCLOAK_URL}realms/techforce/protocol/openid-connect/token`,
            headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            },
            data: data,
        };
        const response = await axios(config);
        return response
        
    }catch(error){
        return {message:"invalid current password" , status: error.response.status}
    }
}